import script from "./EditBet.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBet.vue?vue&type=script&setup=true&lang=js"

import "./EditBet.vue?vue&type=style&index=0&id=57a376ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a376ef"]])

export default __exports__